import { useMutation } from "@/compat/reactQuery";
import shareGroupService from "../../services/shareGroupService";

const useDeleteShareGroup = () => useMutation(shareGroupService.deleteShareGroup);

export default useDeleteShareGroup;
